import { z } from 'zod'

export const SearchSchema = z.object({
  countryId: z.number().optional(),
  isHot: z.number().max(1).optional(),
  showOnCountryHomepage: z.number().max(1).optional(),
  status: z.number().max(1).optional(),
  page: z.number().default(1),
  size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
